import { useEffect, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { useApi } from '../../hooks/useApi';
import { useAuth } from '../../hooks/useAuth';

function VerifyEmailPage() {
    const { request } = useApi();
    const { setUser } = useAuth();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const [state, setState] = useState(token ? 'pending' : 'missing');
    const [message, setMessage] = useState('');

    const title = useMemo(() => {
        if (state === 'success') return 'Email подтвержден';
        if (state === 'pending') return 'Подтверждаем email';
        return 'Подтверждение email';
    }, [state]);

    useEffect(() => {
        if (!token) return;

        let cancelled = false;

        const confirmEmail = async () => {
            try {
                const updatedUser = await request('/api/v1/auth/verify-email/confirm', {
                    method: 'POST',
                    body: JSON.stringify({ token }),
                });
                if (!cancelled) {
                    setUser(updatedUser);
                    setState('success');
                    setMessage('Почта подтверждена. Теперь можно войти в аккаунт.');
                }
            } catch (error) {
                if (!cancelled) {
                    setState('error');
                    setMessage(error.message || 'Не удалось подтвердить email.');
                }
            }
        };

        confirmEmail();

        return () => {
            cancelled = true;
        };
    }, [token, request, setUser]);

    return (
        <div className="app">
            <main className="app__shell">
                <section className="panel panel--auth">
                    <h1>{title}</h1>
                    {state === 'pending' && <p>Пожалуйста, подождите.</p>}
                    {state === 'missing' && (
                        <p>В ссылке нет токена подтверждения. Запросите новую ссылку на странице входа.</p>
                    )}
                    {(state === 'success' || state === 'error') && <p>{message}</p>}
                    <Link className="button-link" to="/">
                        Вернуться на главную
                    </Link>
                </section>
            </main>
        </div>
    );
}

export default VerifyEmailPage;
